export default __webpack_public_path__ + "static/media/Colostrum_replacer.ac425562.jpg";